import { useEffect, useState } from 'react'
import { confirmable, createConfirmation, ReactConfirmProps } from 'react-confirm'
import { Modal, Select } from 'stories/components'

interface ITeamSearchOption {
  title?: string
  inputTitle?: string
  value?: string | number
  teamList?: Record<number, string>
}

interface TeamSearchProps extends ReactConfirmProps {
  options: ITeamSearchOption
}

const TeamSearchDialog = ({ show, proceed, options }: TeamSearchProps) => {
  const [lastUpdatedAt, setLastUpdatedAt] = useState(Date.now())
  const [value, setValue] = useState(options.value)
  const { title, inputTitle, teamList } = options

  useEffect(() => {
    setLastUpdatedAt(Date.now())
  }, [show])

  const handleOk = () => {
    if (value && teamList) {
      const teamId = typeof value === 'string' ? parseInt(value) : value
      proceed({
        id: teamId,
        name: teamList[teamId],
      } as any)
    } else {
      proceed(false as any)
    }
  }

  return (
    <Modal
      button={<span></span>}
      title={title || 'Team Search'}
      titleOkay="Okay"
      init={false}
      isOpen={show}
      disabled={!value}
      lastUpdatedAt={lastUpdatedAt}
      onOk={handleOk}
      onClose={() => proceed(false as any)}
      childLevel={1}
    >
      <div className="w-120 text-sm">
        <Select
          title={inputTitle || 'Team'}
          id="teamSearch"
          options={teamList || {}}
          value={value?.toString()}
          onChange={(newValue) => setValue(newValue)}
          hasDefaultOption={true}
          defaultOptionText="Select a team"
          sort={true}
        />
      </div>
    </Modal>
  )
}

const teamSearchDlg = confirmable(TeamSearchDialog)

const createTeamSearchDlg = createConfirmation(teamSearchDlg)

export const openTeamSearchDlg = (options: ITeamSearchOption = {}) => createTeamSearchDlg({ options })
